import { Observable } from "rxjs";
import { UseCase } from "../../../base/use-case";
import { TypeCanalModel } from "../../../models/configuration/type-canal.model";
import { ConfigurationRepository } from "../../../repositories/configuration.repository";

export class DeleteTypeCanalUseCase implements UseCase<{ Id: string}, TypeCanalModel> {
    constructor(private TypeCanalRepository: ConfigurationRepository) { }
    execute(
        params: {Id: string},
    ): Observable<TypeCanalModel> {
        return this.TypeCanalRepository.deleteTypeCanal(params);
    }
}
